// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3COUz","button--shadowed":"Button_button--shadowed__2qDow"};